// Case study content per client. All 3 branded clients that link externally
// (Nema TV, Habali TV, Smiles of Loudoun Dentistry) get a full case-study page.
// Metrics here reflect capabilities Push2Stream delivered — swap in real client
// numbers as they become available.

export const CASE_STUDIES = {
  "nema-tv": {
    brand: "Nema TV",
    logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_push2stream-redesign/artifacts/9efja579_NEMA%20TV%20%281%29-min.png",
    color: "#B84DF4",
    url: "https://www.nematv.com",
    region: "Worldwide",
    industry: "Global TV & Diaspora",
    servicesUsed: ["core-cms", "front-apps", "live-streaming", "monetization", "casting"],
    content: {
      en: {
        overline: "Case Study — Global TV & Diaspora",
        headline: "Bringing home to the diaspora, live on every screen.",
        summary: "Nema TV launched an international live TV & VOD service reaching expatriate communities on the devices they actually use — mobile, TV and web — powered end-to-end by Push2Stream.",
        challenge: {
          title: "The challenge",
          paragraphs: [
            "Expatriate communities want live news, culture and entertainment from home — on the same phones and TVs they already use. But delivering global channels with local latency, per-country content rights and a consistent viewing experience across a dozen device families is a serious engineering project.",
            "Nema TV needed to launch quickly, ship on every major streaming platform at day one, and keep operating costs predictable while its subscriber base grew across five continents.",
          ],
        },
        solution: {
          title: "The solution",
          paragraphs: [
            "Push2Stream delivered a turnkey stack: Push Core™ middleware for subscribers, content and entitlements; Push Front™ native apps for iOS, Android, Fire TV, Apple TV, Android TV, Roku and Web; carrier-grade live ingest with a global edge CDN; and a unified monetization engine supporting subscriptions, in-app billing and promotional codes.",
            "Country-level entitlements and geo-controls were built into the platform so Nema TV could honour content licensing while still reaching every market its audience lives in.",
          ],
        },
        results: {
          title: "The results",
          metrics: [
            { value: "16", label: "streaming platforms shipped" },
            { value: "40+", label: "countries served" },
            { value: "< 3s", label: "live latency (LL-HLS)" },
            { value: "99.95%", label: "playback uptime SLA" },
          ],
          paragraphs: [
            "Nema TV went live across all major device families on Push2Stream's edge CDN. Adaptive-bitrate delivery and LL-HLS keep buffering rates under 1% even on mobile networks abroad, and country-level access controls let the team clear new content deals without a re-architecture.",
          ],
        },
        testimonial: null,
      },
      fr: {
        overline: "Étude de cas — TV mondiale & diaspora",
        headline: "La maison en direct pour la diaspora, sur chaque écran.",
        summary: "Nema TV a lancé un service international de TV live et VOD qui touche les communautés expatriées sur les appareils qu'elles utilisent — mobile, TV et web — propulsé de bout en bout par Push2Stream.",
        challenge: {
          title: "Le défi",
          paragraphs: [
            "Les communautés expatriées veulent l'actualité, la culture et le divertissement du pays — sur les téléphones et TV qu'elles utilisent déjà. Mais délivrer des chaînes mondiales avec une latence locale, gérer les droits par pays et offrir une expérience cohérente sur une dizaine de familles d'appareils est un vrai projet d'ingénierie.",
            "Nema TV devait lancer vite, être présent sur toutes les plateformes majeures dès le jour un, et garder des coûts d'exploitation prévisibles pendant que sa base d'abonnés grandissait sur cinq continents.",
          ],
        },
        solution: {
          title: "La solution",
          paragraphs: [
            "Push2Stream a livré une stack clé-en-main : middleware Push Core™ pour abonnés, contenus et droits ; applis natives Push Front™ pour iOS, Android, Fire TV, Apple TV, Android TV, Roku et Web ; ingestion live carrier-grade avec CDN edge global ; et moteur de monétisation unifié supportant abonnements, facturation in-app et codes promo.",
            "Les droits par pays et les géo-contrôles sont intégrés à la plateforme pour que Nema TV respecte les licences tout en atteignant chaque marché où vit son audience.",
          ],
        },
        results: {
          title: "Les résultats",
          metrics: [
            { value: "16", label: "plateformes de streaming livrées" },
            { value: "40+", label: "pays desservis" },
            { value: "< 3s", label: "latence live (LL-HLS)" },
            { value: "99,95 %", label: "SLA de disponibilité" },
          ],
          paragraphs: [
            "Nema TV est passé en live sur toutes les familles d'appareils majeures via le CDN edge Push2Stream. La distribution adaptative et LL-HLS maintiennent le buffering sous 1 % même sur les réseaux mobiles à l'étranger, et le contrôle d'accès par pays permet à l'équipe de signer de nouveaux contrats sans refonte.",
          ],
        },
        testimonial: null,
      },
      es: {
        overline: "Caso de estudio — TV global & diáspora",
        headline: "El hogar en vivo para la diáspora, en cada pantalla.",
        summary: "Nema TV lanzó un servicio internacional de TV en vivo y VOD que llega a las comunidades expatriadas en los dispositivos que realmente usan — móvil, TV y web — impulsado de extremo a extremo por Push2Stream.",
        challenge: {
          title: "El reto",
          paragraphs: [
            "Las comunidades expatriadas quieren noticias, cultura y entretenimiento del país — en los teléfonos y TV que ya usan. Pero entregar canales globales con latencia local, gestionar derechos por país y ofrecer una experiencia consistente en una decena de familias de dispositivos es un proyecto de ingeniería serio.",
            "Nema TV necesitaba lanzar rápido, estar en todas las plataformas principales desde el día uno, y mantener costes operativos predecibles mientras su base de suscriptores crecía en cinco continentes.",
          ],
        },
        solution: {
          title: "La solución",
          paragraphs: [
            "Push2Stream entregó un stack llave-en-mano: middleware Push Core™ para suscriptores, contenido y derechos; apps nativas Push Front™ para iOS, Android, Fire TV, Apple TV, Android TV, Roku y Web; ingesta en vivo carrier-grade con CDN edge global; y motor de monetización unificado que soporta suscripciones, facturación in-app y códigos promocionales.",
            "Los derechos por país y los geo-controles están integrados en la plataforma para que Nema TV respete las licencias mientras alcanza cada mercado donde vive su audiencia.",
          ],
        },
        results: {
          title: "Los resultados",
          metrics: [
            { value: "16", label: "plataformas de streaming lanzadas" },
            { value: "40+", label: "países atendidos" },
            { value: "< 3s", label: "latencia en vivo (LL-HLS)" },
            { value: "99,95 %", label: "SLA de uptime" },
          ],
          paragraphs: [
            "Nema TV salió en vivo en todas las familias de dispositivos principales sobre el CDN edge de Push2Stream. El bitrate adaptativo y LL-HLS mantienen el buffering por debajo del 1% incluso en redes móviles en el extranjero, y el control por país permite al equipo firmar nuevos acuerdos sin re-arquitectura.",
          ],
        },
        testimonial: null,
      },
      pt: {
        overline: "Caso de estudo — TV global & diáspora",
        headline: "Casa ao vivo para a diáspora, em cada ecrã.",
        summary: "A Nema TV lançou um serviço internacional de TV ao vivo e VOD que chega às comunidades expatriadas nos dispositivos que realmente usam — mobile, TV e web — impulsionado de ponta a ponta pela Push2Stream.",
        challenge: {
          title: "O desafio",
          paragraphs: [
            "As comunidades expatriadas querem notícias, cultura e entretenimento do país — nos telemóveis e TVs que já usam. Mas entregar canais globais com latência local, gerir direitos por país e oferecer uma experiência consistente em várias famílias de dispositivos é um projeto de engenharia sério.",
            "A Nema TV precisava de lançar rápido, estar em todas as plataformas principais desde o dia um, e manter custos operacionais previsíveis enquanto a sua base de subscritores crescia em cinco continentes.",
          ],
        },
        solution: {
          title: "A solução",
          paragraphs: [
            "A Push2Stream entregou um stack chave-na-mão: middleware Push Core™ para subscritores, conteúdo e direitos; apps nativas Push Front™ para iOS, Android, Fire TV, Apple TV, Android TV, Roku e Web; ingestão ao vivo carrier-grade com CDN edge global; e motor de monetização unificado que suporta subscrições, faturação in-app e códigos promocionais.",
            "Os direitos por país e geo-controlos estão integrados na plataforma para que a Nema TV respeite as licenças enquanto alcança cada mercado onde a sua audiência vive.",
          ],
        },
        results: {
          title: "Os resultados",
          metrics: [
            { value: "16", label: "plataformas de streaming lançadas" },
            { value: "40+", label: "países servidos" },
            { value: "< 3s", label: "latência ao vivo (LL-HLS)" },
            { value: "99,95 %", label: "SLA de uptime" },
          ],
          paragraphs: [
            "A Nema TV ficou ao ar em todas as famílias de dispositivos principais sobre o CDN edge da Push2Stream. O bitrate adaptativo e o LL-HLS mantêm o buffering abaixo de 1% mesmo em redes móveis no estrangeiro, e o controlo por país permite à equipa assinar novos acordos sem re-arquitetura.",
          ],
        },
        testimonial: null,
      },
    },
  },

  "habali-tv": {
    brand: "Habali TV",
    logo: "https://customer-assets.emergentagent.com/job_push2stream-redesign/artifacts/7mrwrjls_2026-06-09_19-55-599.png",
    color: "#9B5DE5",
    url: "https://www.habalitv.com",
    region: "USA · Canada · UK",
    industry: "Live TV & VOD",
    servicesUsed: ["core-cms", "front-apps", "live-streaming", "dvr-catchup", "monetization"],
    content: {
      en: {
        overline: "Case Study — Live TV & VOD for the Diaspora",
        headline: "Live TV, news and culture from around the world — anywhere.",
        summary: "The ultimate streaming destination for the diaspora. Habali TV combines live linear channels with an on-demand library, delivered on every major screen through Push2Stream.",
        challenge: {
          title: "The challenge",
          paragraphs: [
            "Habali TV's audience is spread across the US, Canada, the UK and beyond — with a strong appetite for both live news and rich on-demand libraries in their native languages. That audience is mobile-first but wants a big-screen experience at home.",
            "The team needed a modern OTT platform that could combine live channels, cloud DVR/catchup and a growing VOD library without stitching together five vendors.",
          ],
        },
        solution: {
          title: "The solution",
          paragraphs: [
            "Push2Stream unified live and on-demand delivery under a single Push Core™ middleware, with Push Front™ apps on iOS, Android, Fire TV, Apple TV, Roku, Android TV and the Web. Cloud DVR / catchup automatically turns every live moment into on-demand VOD.",
            "The monetization engine supports subscriptions and in-app billing on Apple and Google, so viewers in every market can pay the way they're used to.",
          ],
        },
        results: {
          title: "The results",
          metrics: [
            { value: "3", label: "primary markets (US · CA · UK)" },
            { value: "7-14 days", label: "cloud catchup window" },
            { value: "< 3s", label: "live latency" },
            { value: "1-tap", label: "casting to any TV" },
          ],
          paragraphs: [
            "Habali TV runs live and VOD side-by-side with a consistent UX on every device. Cloud DVR gives every viewer the confidence they'll never miss a show, and Chromecast + AirPlay let mobile discovery become big-screen viewing in one tap.",
          ],
        },
        testimonial: null,
      },
      fr: {
        overline: "Étude de cas — TV live & VOD pour la diaspora",
        headline: "TV live, actualité et culture du monde entier — partout.",
        summary: "La destination de streaming ultime pour la diaspora. Habali TV combine chaînes linéaires live et bibliothèque à la demande, livrées sur chaque grand écran grâce à Push2Stream.",
        challenge: {
          title: "Le défi",
          paragraphs: [
            "L'audience de Habali TV est répartie aux USA, au Canada, au Royaume-Uni et au-delà — avec un fort appétit pour l'actu live et des bibliothèques VOD riches dans leur langue. Cette audience est mobile-first mais veut une expérience grand écran à la maison.",
            "L'équipe avait besoin d'une plateforme OTT moderne capable de combiner chaînes live, cloud DVR/catchup et une bibliothèque VOD grandissante sans assembler cinq fournisseurs.",
          ],
        },
        solution: {
          title: "La solution",
          paragraphs: [
            "Push2Stream a unifié le live et le VOD sous un seul middleware Push Core™, avec des applis Push Front™ sur iOS, Android, Fire TV, Apple TV, Roku, Android TV et Web. Le cloud DVR / catchup transforme automatiquement chaque moment live en VOD à la demande.",
            "Le moteur de monétisation supporte les abonnements et la facturation in-app Apple et Google, pour que les spectateurs de chaque marché paient comme ils en ont l'habitude.",
          ],
        },
        results: {
          title: "Les résultats",
          metrics: [
            { value: "3", label: "marchés principaux (US · CA · UK)" },
            { value: "7-14 jours", label: "fenêtre de catchup cloud" },
            { value: "< 3s", label: "latence live" },
            { value: "1-tap", label: "cast vers n'importe quelle TV" },
          ],
          paragraphs: [
            "Habali TV fait tourner live et VOD côte à côte avec une UX cohérente sur chaque appareil. Le cloud DVR donne à chaque spectateur la certitude de ne rien manquer, et Chromecast + AirPlay transforment la découverte mobile en visionnage grand écran d'un tap.",
          ],
        },
        testimonial: null,
      },
      es: {
        overline: "Caso de estudio — TV en vivo y VOD para la diáspora",
        headline: "TV en vivo, noticias y cultura de todo el mundo — donde sea.",
        summary: "El destino definitivo de streaming para la diáspora. Habali TV combina canales lineales en vivo con una biblioteca on-demand, entregada en cada pantalla principal a través de Push2Stream.",
        challenge: {
          title: "El reto",
          paragraphs: [
            "La audiencia de Habali TV está repartida en EE.UU., Canadá, Reino Unido y más allá — con un fuerte apetito por noticias en vivo y ricas bibliotecas VOD en su idioma. Es una audiencia mobile-first que también quiere experiencia de pantalla grande en casa.",
            "El equipo necesitaba una plataforma OTT moderna capaz de combinar canales en vivo, cloud DVR/catchup y una biblioteca VOD creciente sin unir cinco proveedores.",
          ],
        },
        solution: {
          title: "La solución",
          paragraphs: [
            "Push2Stream unificó en vivo y bajo demanda con un solo middleware Push Core™, con apps Push Front™ en iOS, Android, Fire TV, Apple TV, Roku, Android TV y Web. El cloud DVR / catchup convierte automáticamente cada momento en vivo en VOD bajo demanda.",
            "El motor de monetización soporta suscripciones y facturación in-app Apple y Google, para que los espectadores de cada mercado paguen como están acostumbrados.",
          ],
        },
        results: {
          title: "Los resultados",
          metrics: [
            { value: "3", label: "mercados principales (US · CA · UK)" },
            { value: "7-14 días", label: "ventana de catchup en la nube" },
            { value: "< 3s", label: "latencia en vivo" },
            { value: "1-tap", label: "cast a cualquier TV" },
          ],
          paragraphs: [
            "Habali TV opera en vivo y VOD lado a lado con una UX consistente en cada dispositivo. El cloud DVR le da a cada espectador la confianza de que no perderá un show, y Chromecast + AirPlay convierten el descubrimiento móvil en visualización de pantalla grande con un toque.",
          ],
        },
        testimonial: null,
      },
      pt: {
        overline: "Caso de estudo — TV ao vivo & VOD para a diáspora",
        headline: "TV ao vivo, notícias e cultura de todo o mundo — em qualquer lugar.",
        summary: "O destino de streaming definitivo para a diáspora. A Habali TV combina canais lineares ao vivo com uma biblioteca on-demand, entregue em cada ecrã principal através da Push2Stream.",
        challenge: {
          title: "O desafio",
          paragraphs: [
            "A audiência da Habali TV está espalhada pelos EUA, Canadá, Reino Unido e mais além — com forte apetite por notícias ao vivo e bibliotecas VOD ricas na sua língua. É uma audiência mobile-first que também quer experiência de ecrã grande em casa.",
            "A equipa precisava de uma plataforma OTT moderna capaz de combinar canais ao vivo, cloud DVR/catchup e uma biblioteca VOD crescente sem ligar cinco fornecedores.",
          ],
        },
        solution: {
          title: "A solução",
          paragraphs: [
            "A Push2Stream unificou ao vivo e on-demand num só middleware Push Core™, com apps Push Front™ em iOS, Android, Fire TV, Apple TV, Roku, Android TV e Web. O cloud DVR / catchup converte automaticamente cada momento ao vivo em VOD.",
            "O motor de monetização suporta subscrições e faturação in-app Apple e Google, para que os espectadores de cada mercado paguem como estão habituados.",
          ],
        },
        results: {
          title: "Os resultados",
          metrics: [
            { value: "3", label: "mercados principais (US · CA · UK)" },
            { value: "7-14 dias", label: "janela de catchup na nuvem" },
            { value: "< 3s", label: "latência ao vivo" },
            { value: "1-tap", label: "cast para qualquer TV" },
          ],
          paragraphs: [
            "A Habali TV opera ao vivo e VOD lado a lado com uma UX consistente em cada dispositivo. O cloud DVR dá a cada espectador a confiança de que não vai perder um show, e o Chromecast + AirPlay transformam a descoberta móvel em visualização em ecrã grande com um toque.",
          ],
        },
        testimonial: null,
      },
    },
  },

  "smiles-of-loudoun": {
    brand: "Smiles of Loudoun Dentistry",
    logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_push2stream-redesign/artifacts/kbh0vkd2_Smiles%20Of%20Loudoun%202%20logo%20300.jpg",
    color: "#F5D06F",
    url: "https://www.smilesofloudoun.com",
    region: "Leesburg, Virginia",
    industry: "Enterprise & Local Business",
    servicesUsed: ["core-cms", "cloud-playout", "stb", "casting"],
    content: {
      en: {
        overline: "Case Study — Enterprise & Local Business",
        headline: "In-office patient TV that keeps a family dental practice on brand.",
        summary: "Smiles of Loudoun Dentistry, a family and cosmetic dental practice in Leesburg, Virginia, uses Push2Stream to run branded in-office patient TV and digital signage across the practice.",
        challenge: {
          title: "The challenge",
          paragraphs: [
            "A modern dental practice is a calm, curated environment. Random cable TV in the waiting room and treatment bays undermines the brand: uncontrolled ads, off-tone news segments and outdated content.",
            "Smiles of Loudoun wanted a fully branded on-screen experience — welcome messages, oral-health education, seasonal promotions and calm ambient content — running reliably every day without an IT team.",
          ],
        },
        solution: {
          title: "The solution",
          paragraphs: [
            "Push2Stream delivered a small, purpose-built deployment: a branded set-top box on each screen, a MoxyPlay cloud playout schedule that runs the practice's ambient loop and educational segments, and Push Core™ to manage device inventory and content updates from one place.",
            "Every screen is on the practice's brand — from welcome messages to seasonal offers — with content changes pushed from a browser, not from behind the treatment chairs.",
          ],
        },
        results: {
          title: "The results",
          metrics: [
            { value: "100%", label: "on-brand in-office content" },
            { value: "0", label: "IT team required" },
            { value: "Browser", label: "content updates in minutes" },
            { value: "24/7", label: "unattended scheduled playout" },
          ],
          paragraphs: [
            "Smiles of Loudoun's operatory and reception screens now run a curated, always-on schedule that reinforces the practice's calm, professional brand. Content updates take minutes from any browser — no cables, no service calls, no ads for competing clinics.",
          ],
        },
        testimonial: null,
      },
      fr: {
        overline: "Étude de cas — Entreprise & entreprise locale",
        headline: "TV patient en cabinet qui garde un cabinet dentaire familial dans son image.",
        summary: "Smiles of Loudoun Dentistry, cabinet dentaire familial et esthétique à Leesburg, Virginie, utilise Push2Stream pour opérer une TV patient et un affichage numérique brandés à travers le cabinet.",
        challenge: {
          title: "Le défi",
          paragraphs: [
            "Un cabinet dentaire moderne est un environnement calme et soigné. La TV câblée aléatoire en salle d'attente et en soins nuit à l'image : pubs non contrôlées, actu inadéquate, contenus dépassés.",
            "Smiles of Loudoun voulait une expérience à l'écran entièrement brandée — messages de bienvenue, éducation santé bucco-dentaire, promos saisonnières et contenus ambient calmes — fonctionnant fiablement chaque jour sans équipe IT.",
          ],
        },
        solution: {
          title: "La solution",
          paragraphs: [
            "Push2Stream a livré un déploiement compact et sur mesure : un décodeur brandé par écran, une grille MoxyPlay cloud pilotant la boucle ambient et les segments éducatifs du cabinet, et Push Core™ pour gérer l'inventaire des appareils et les mises à jour de contenu depuis un seul endroit.",
            "Chaque écran est à l'image du cabinet — de la bienvenue aux offres saisonnières — avec des changements de contenu poussés depuis un navigateur, pas derrière les fauteuils.",
          ],
        },
        results: {
          title: "Les résultats",
          metrics: [
            { value: "100 %", label: "contenu en cabinet à l'image" },
            { value: "0", label: "équipe IT nécessaire" },
            { value: "Navigateur", label: "mises à jour en minutes" },
            { value: "24/7", label: "playout planifié sans surveillance" },
          ],
          paragraphs: [
            "Les écrans de la salle d'attente et des salles de soins font tourner une grille toujours-active qui renforce l'image calme et professionnelle du cabinet. Les mises à jour de contenu prennent quelques minutes depuis n'importe quel navigateur — pas de câbles, pas de dépannage, pas de pub pour la concurrence.",
          ],
        },
        testimonial: null,
      },
      es: {
        overline: "Caso de estudio — Empresa & negocio local",
        headline: "TV para pacientes en consulta que mantiene una clínica dental familiar en marca.",
        summary: "Smiles of Loudoun Dentistry, consulta dental familiar y estética en Leesburg, Virginia, usa Push2Stream para operar TV de pacientes y señalización digital de marca en toda la clínica.",
        challenge: {
          title: "El reto",
          paragraphs: [
            "Una consulta dental moderna es un entorno calmo y cuidado. La TV por cable aleatoria en la sala de espera y las salas de tratamiento perjudica la marca: anuncios sin control, noticias fuera de tono, contenido desactualizado.",
            "Smiles of Loudoun quería una experiencia en pantalla totalmente de marca — mensajes de bienvenida, educación en salud bucal, promos estacionales y contenido ambient calmo — funcionando de forma fiable cada día sin equipo IT.",
          ],
        },
        solution: {
          title: "La solución",
          paragraphs: [
            "Push2Stream entregó un despliegue compacto y a medida: un STB de marca por pantalla, una grilla MoxyPlay en la nube que ejecuta el bucle ambient y segmentos educativos de la clínica, y Push Core™ para gestionar el inventario de dispositivos y actualizaciones desde un solo lugar.",
            "Cada pantalla está en la marca de la clínica — desde bienvenidas hasta ofertas estacionales — con cambios de contenido lanzados desde un navegador, no desde detrás de los sillones.",
          ],
        },
        results: {
          title: "Los resultados",
          metrics: [
            { value: "100 %", label: "contenido en consulta en marca" },
            { value: "0", label: "equipo IT necesario" },
            { value: "Navegador", label: "actualizaciones en minutos" },
            { value: "24/7", label: "playout programado sin supervisión" },
          ],
          paragraphs: [
            "Las pantallas del área operatoria y recepción de Smiles of Loudoun ejecutan una grilla siempre activa que refuerza la marca calma y profesional de la clínica. Las actualizaciones tardan minutos desde cualquier navegador — sin cables, sin llamadas técnicas, sin anuncios de la competencia.",
          ],
        },
        testimonial: null,
      },
      pt: {
        overline: "Caso de estudo — Empresa & negócio local",
        headline: "TV para pacientes em consultório que mantém uma clínica dentária familiar na marca.",
        summary: "A Smiles of Loudoun Dentistry, clínica dentária familiar e estética em Leesburg, Virgínia, usa a Push2Stream para operar TV para pacientes e sinalização digital de marca em toda a clínica.",
        challenge: {
          title: "O desafio",
          paragraphs: [
            "Uma clínica dentária moderna é um ambiente calmo e curado. TV por cabo aleatória na sala de espera e nas salas de tratamento prejudica a marca: anúncios sem controlo, notícias fora de tom, conteúdo desatualizado.",
            "A Smiles of Loudoun queria uma experiência de ecrã totalmente de marca — mensagens de boas-vindas, educação em saúde oral, promos sazonais e conteúdo ambient calmo — a correr de forma fiável todos os dias sem equipa de TI.",
          ],
        },
        solution: {
          title: "A solução",
          paragraphs: [
            "A Push2Stream entregou uma implementação compacta e à medida: um STB de marca por ecrã, uma grelha MoxyPlay na nuvem que executa o loop ambient e segmentos educativos da clínica, e o Push Core™ para gerir o inventário de dispositivos e atualizações a partir de um único sítio.",
            "Cada ecrã está na marca da clínica — de boas-vindas a ofertas sazonais — com alterações de conteúdo enviadas a partir de um navegador, não de trás das cadeiras.",
          ],
        },
        results: {
          title: "Os resultados",
          metrics: [
            { value: "100 %", label: "conteúdo em consultório na marca" },
            { value: "0", label: "equipa de TI necessária" },
            { value: "Navegador", label: "atualizações em minutos" },
            { value: "24/7", label: "playout programado sem supervisão" },
          ],
          paragraphs: [
            "Os ecrãs da área operatória e receção da Smiles of Loudoun executam uma grelha sempre ativa que reforça a marca calma e profissional da clínica. As atualizações demoram minutos a partir de qualquer navegador — sem cabos, sem chamadas técnicas, sem anúncios da concorrência.",
          ],
        },
        testimonial: null,
      },
    },
  },
};

// Section-heading labels + generic CTAs used inside CaseStudy.jsx
export const CASE_LABELS = {
  en: {
    backToClients: "All clients",
    stackHeading: "Push2Stream services used",
    ctaTitleA: "Ready to run a service like",
    ctaTitleB: "?",
    visitSite: "Visit site",
    bookDemo: "Book a demo",
  },
  fr: {
    backToClients: "Tous les clients",
    stackHeading: "Services Push2Stream utilisés",
    ctaTitleA: "Prêt à opérer un service comme",
    ctaTitleB: " ?",
    visitSite: "Visiter le site",
    bookDemo: "Réserver une démo",
  },
  es: {
    backToClients: "Todos los clientes",
    stackHeading: "Servicios Push2Stream usados",
    ctaTitleA: "¿Listo para operar un servicio como",
    ctaTitleB: "?",
    visitSite: "Visitar el sitio",
    bookDemo: "Reservar demo",
  },
  pt: {
    backToClients: "Todos os clientes",
    stackHeading: "Serviços Push2Stream usados",
    ctaTitleA: "Pronto para operar um serviço como",
    ctaTitleB: "?",
    visitSite: "Visitar o site",
    bookDemo: "Marcar demo",
  },
};
